import { render, staticRenderFns } from "./DotsHorizontal.vue?vue&type=template&id=079a5c9e&functional=true&"
import script from "./DotsHorizontal.vue?vue&type=script&lang=js&"
export * from "./DotsHorizontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports